// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","dotNav":"_13I1ts","active":"_1C84Jx","fadeInFrames":"ZCsTuH"};